// The six emoji a kudos can carry, by the name the server stores. The glyph is what people see; the label is
// what a screen reader says and what the picker names.

export const KUDOS_EMOJI: Array<{ key: string; glyph: string; label: string }> = [
  { key: 'clap', glyph: '👏', label: 'Applause' },
  { key: 'raised_hands', glyph: '🙌', label: 'Well done' },
  { key: 'rocket', glyph: '🚀', label: 'Shipped it' },
  { key: 'bulb', glyph: '💡', label: 'Great idea' },
  { key: 'tada', glyph: '🎉', label: 'Celebration' },
  { key: 'heart', glyph: '❤️', label: 'Thank you' },
];

export const NOTE_MAX = 140;

export const emojiOf = (key: string | undefined) => KUDOS_EMOJI.find((e) => e.key === key);
